import langKey from 'i18n/keys';

const english = {
  [langKey.urgent_text]:
    'If this is an emergency, move to a safe place and call 911 or an emergency services number as soon as it is safe to do so.',
  [langKey.victim_question_title]:
    'Is there someone else who may have been injured or may be in danger?',
  [langKey.emergency_text]: `Move to a safe place and call 911 or the local emergency number as soon as
      it is safe for you to do so. If possible, have someone else call Security
      while you’re on the phone with the emergency dispatcher.`,
  [langKey.complete]: `Complete`,
  [langKey.back]: `Back`,
  [langKey.continue]: `Continue`,
  [langKey.please_fill_out]: `Please fill out the following information.`,
  [langKey.my_name]: `My Name`,
  [langKey.phone_number]: `Phone Number`,
  [langKey.email_address]: `Preferred Email Address`,
  [langKey.issue_box]: `Check this box if the issue isn't urgent and you'd
                    rather be interviewed by phone than answer questions
                    through this app.`,
  [langKey.work_zip_code]: `Worksite Zip Code`,
  [langKey.specific_worksite]: `Specific Worksite (optional)`,
  [langKey.gender]: `Gender`,
  [langKey.race]: `Race`,
  [langKey.approx_age]: `approxAge`,
  [langKey.approx_age]: `Approximate Age`,
  [langKey.height]: `height`,
  [langKey.weight]: `Weight`,
  [langKey.hair_color]: `Hair Color`,
  [langKey.other_details]: `Other details`,
  [langKey.name_everyone]: `You’ll be able to name everyone who is causing the problem, but first
        please tell us as much as you can about the`,
  [langKey.main_person]: `main person`,
  [langKey.causing_the_problem]: `causing the problem:`,
  [langKey.subject]: `Subject #`,
  [langKey.provide_whatever_info]: `Provide whatever information you have:`,
  [langKey.person_name]: `personName`,
  [langKey.person_type]: `Person Type`,
  [langKey.name]: `Name`,
  [langKey.employer]: `employer`,
  [langKey.employer]: `Employer`,
  [langKey.work_location]: `workLocation`,
  [langKey.work_location]: `Work Location`,
  [langKey.email]: `email`,
  [langKey.email]: `Email`,
  [langKey.address]: `Address`,
  [langKey.city]: `City`,
  [langKey.state]: `State`,
  [langKey.zip]: `Zip`,
  [langKey.relationship_to_company]: `Relationship to the company`,
  [langKey.other]: `Other`,
  [langKey.employee]: `Employee`,
  [langKey.please_describe]: `Please describe`,
  [langKey.physical_description]: `Can you give their physical description?`,
  [langKey.yes]: `Yes`,
  [langKey.no]: `No`,
  [langKey.vehicle_information]: `Can you give their vehicle’s physical description?`,
  [langKey.year]: `Year`,
  [langKey.make]: `Make`,
  [langKey.model]: `model`,
  [langKey.model]: `Model`,
  [langKey.color]: `Color`,
  [langKey.license_tag]: `License Tag`,
  [langKey.help]: `Help`,
  [langKey.written]: `Written`,
  [langKey.oral]: `Oral`,
  [langKey.introduction]: `Introduction`,
  [langKey.personal_identification]: `Personal Identification`,
  [langKey.questions]: `Questions`,
  [langKey.please_select_one]: `Please select one.`,
  [langKey.please_select_all_apply]: `Please select all that apply.`,
  [langKey.intro_text_1]: ` is a way for you to report concerns about potential dangers, misconduct, or other uncomfortable situations affecting you or your workplace.`,
  [langKey.intro_text_2]: `Please fill out as much as you can, but most questions are optional. The information you share is transmitted securely and handled discreetly to protect your safety and privacy.`,
  [langKey.intro_text_3]: `Call 911 or your local emergency number to report a life-threatening emergency before submitting a report here.`,
  [langKey.thanks_reporting]: `Thank you very much for reporting this matter and for helping to keep everyone at work safe!`,
  [langKey.your_unique_code]: `Your unique code for this report is`,
  [langKey.write_report_id]: `Please take a photo, make a note, or copy the 5-digit Report Identification Code for your records. You will need this code to check the status of your report or to provide additional information later.`,
  [langKey.remember_emergency]: `And remember, if there’s an emergency in which someone is at
                    immediate risk of getting hurt, make sure you’re in a safe
                    place and then call 911 or your local emergency number
                    immediately. If possible, have someone call Security while
                    you’re on the phone with the emergency dispatcher.`,
  [langKey.receive_email_question]: `Do you want to receive email notifications?`,
  [langKey.SUBMIT]: `submit`,
  [langKey.life_ring]: `Life Ring`,
  [langKey.welcome]: `Welcome.`,
  [langKey.here_to_help]: `We're here to help.`,
  [langKey.file_new_report]: `Create a New Report`,
  [langKey.file_report]: `I’d like to file a new report`,
  [langKey.i_would_like_a]: `I’d like to file a`,
  [langKey.new_report]: `new report`,
  [langKey.add_to_existing]: `Add to Existing Report`,
  [langKey.review_case_status]: `Case Status`,
  [langKey.status_updates]: `Status Updates`,
  [langKey.no_data_found]: `No data found`,
  [langKey.add_new_information]: `Please add new information to your case by uploading files or
            writing below.`,
  [langKey.file_to_upload]: `Select a File to Upload`,
  [langKey.or_drag_here]: `Or drag & drop it here`,
  [langKey.preview]: `Preview`,
  [langKey.file_name]: `File Name`,
  [langKey.edit_file]: `Edit File`,
  [langKey.image]: `image`,
  [langKey.replace]: `Replace`,
  [langKey.delete]: `Delete`,
  [langKey.no_record_found]: `No record found!`,
  [langKey.enter_unique_report]: `Please enter your unique Report ID`,
  [langKey.report_id]: `Report ID`,
  [langKey.update_report]: `updateReport`,
  [langKey.thanks_for_update]: `Thank you for submitting your update — we value the safety and well-being of every employee!`,
  [langKey.description]: `Description`,
  [langKey.landingpage_selectdomain]: `Please use your organization’s domain to access the Say Something™ platform.`,
  [langKey.title]: `Title`,
  [langKey.relationship_to_sender]: `Relationship to the sender`,
  [langKey.number_of_communications]: `Number of communications received`
};

export default english;
